import { i18n } from "@/setup/i18n-setup";
import { PropSelectGroup } from "./prop-select-group";
import { PropSelectItem } from "./prop-select-item";
import { convertIModelToConditionPropSelectGroup } from "./convert-imodel-to-prop-select-group";
import { getModel } from "../models/model";

export function getReminderLayoutPropSelectGroup():PropSelectGroup{
	let result = new PropSelectGroup("", "");
	result.items.push(new PropSelectItem(i18n.t("common.title"), "Title", "string"));
	result.items.push(new PropSelectItem(i18n.t("common.content"), "Content", "string"));
	result.items.push(new PropSelectItem(i18n.t("common.signature"), "Signature", "string"));
	result.items.push(new PropSelectItem(i18n.t("components.reminder-layout-editor.create-context"), "CreateContext", "string", "create-context"));

	let group = convertIModelToConditionPropSelectGroup(getModel("Contact"));
	group.path = "Contact";
	group.name = i18n.t("models.friendlyNames.Contact.name");
	result.groups.push(group);

	group = convertIModelToConditionPropSelectGroup(getModel("ContactAddress"));
	group.name = i18n.t("models.friendlyNames.ContactAddress.name");
	result.groups.push(group);
	return result;
}